/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Types of benefit inventory available in the discovery system.
 */
export enum ItemType {
  MEDICAL_PLAN = 'MEDICAL_PLAN',
}
